<template>
  <page-outline :title="pageTitle" :accessibilityCompliant="true">
    <template slot="pageContent">
      <b-container fluid>
        <b-row class="justify-content-center align-items-center">
          <b-col cols="12" class="text-center mt-5">
            <h5 class="text-muted">
              {{ $t('accessibility.page_under_construction') }}
            </h5>
          </b-col>
        </b-row>
      </b-container>
    </template>
  </page-outline>
</template>

<script>
import PageOutline from '@/components/common/PageOutline.vue'

export default {
  name: 'AccessibilitePage',
  components: {
    'page-outline': PageOutline
  },
  data() {
    return {
      pageTitle: this.$t('accessibility.title')
    }
  }
}
</script>
